<mat-form-field style="max-width: 100%;width: 100%"  [formGroup]="form">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate placeholder="Début" [formControlName]="startControlName">
    <input matEndDate placeholder="Fin" [formControlName]="endControlName" >
  </mat-date-range-input>
  <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
